<template>
<div class="footer-box" v-show="showfoot">
	<div class="footer-top">
		<span class="footer-fun"><a href="http://m.yourhr.com.cn/privacy_policy.html" target="_blank" rel="noopener noreferrer">用户协议</a></span>
		<span class="footer-fun" @click="toUrl('/dispute')">纠纷处理</span>
		<span class="footer-fun" @click="toUrl('/feedback')">意见处理</span>
		<span class="footer-fun" @click="MEIQIA()">联系我们</span>
		<span class="footer-fun"><a href="https://baike.baidu.com/item/%E4%B8%AD%E5%AE%9C%E6%95%99%E8%82%B2/3025781?fr=aladdin" target="_blank" rel="noopener noreferrer">关于我们</a></span>
	</div>
	<!-- <div class="copy-right">广州中宜科技有限公司&nbsp;&nbsp;广州市天河区黄村路57号二楼（部门：C291）&nbsp;&nbsp;中宜版权所有 &nbsp;&nbsp;<a href="http://www.beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">备案号©&nbsp;粤ICP备15054313号</a></div> -->
	<div class="copy-right">广州格兰堂信息科技有限公司版权所有 &nbsp;&nbsp;<a href="http://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">备案号©&nbsp;粤ICP备12001590号</a></div>
</div>
</template>
<script>
 export default{
        data(){
            return{
				showfoot: true
            }
        },
        methods:{
            MEIQIA(){
                let that = this;
                if (!JSON.parse(tools.cache.get('status'))) {
                    that.$store.state.app.dialogVisible = true;
                    that.$store.state.app.sin_login = true;
                    return
                }
                _MEIQIA('showPanel');
			}
        },
        watch: {
			'$route'(val) {
				if(val.path == '/webshopping/shopping_cart') {
					this.showfoot = false
				} else {
					this.showfoot = true
				}
			}
        },
        components:{

        },
        filters: {

        },
        mounted(){
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
.footer-box{
	// margin-top:9px;
	span{
		cursor: pointer;
		display: inline-block;
		width: 100px;
		border-left: 1px solid #c0c0c0;
		a{
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
	.footer-top{
		width: 100%;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-bottom: 1px solid #fafafa;
		.footer-fun{
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 12px;
			color: #6d6d6d;
			&:hover{
				color: #7b95e7;
			}
			&:last-of-type{
				border-right: 1px solid #c0c0c0;
			}
		}
	}
	.copy-right{
		width: 100%;
		height: 34px;
		display: flex;
		align-items: center;
		align-content: center;
		justify-content: center;
		font-size: 12px;
		color: #b2b2b2;
		a{
			&:hover{
				color: #7b95e7;
			}
		}
	}
	background: #FFFFFF;

}
</style>


// WEBPACK FOOTER //
// Footer.vue?38356394